export default __webpack_public_path__ + "beta-maps-examples-user-location-view-960-4fd76fe726e079da5693b670951ac37d.webp";